module.exports = __webpack_public_path__ + "img/2_2-industriale-concessionario-2.ecba5548.png";